import { render, staticRenderFns } from "./Wrong.vue?vue&type=template&id=3febaab2&scoped=true&"
var script = {}
import style0 from "./Wrong.vue?vue&type=style&index=0&id=3febaab2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3febaab2",
  null
  
)

export default component.exports